export const FORTUNE_GETTERS = {
  IS_NOT_EMPTY: 'isNotEmpty',
  IS_LOADING: 'isLoading',
  LATEST_QUIZ: 'latestQuiz',
  SEARCH: 'search',
}
